/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ScheduledPruneDto } from '../models/ScheduledPruneDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class DomainPruneControllerService {

    /**
     * @param name
     * @param component
     * @param port
     * @returns ScheduledPruneDto OK
     * @throws ApiError
     */
    public static getDomainPruningSchedule(
        name: string,
        component: string,
        port: number = 5019,
    ): CancelablePromise<ScheduledPruneDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/domains/{name}/prune',
            path: {
                'name': name,
            },
            query: {
                'port': port,
                'component': component,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * @param name
     * @param component
     * @param requestBody
     * @param port
     * @returns any Created
     * @throws ApiError
     */
    public static createDomainPruningSchedule(
        name: string,
        component: string,
        requestBody: ScheduledPruneDto,
        port: number = 5019,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/domains/{name}/prune',
            path: {
                'name': name,
            },
            query: {
                'port': port,
                'component': component,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * @param name
     * @param component
     * @param port
     * @returns void
     * @throws ApiError
     */
    public static deleteDomainPruningSchedule(
        name: string,
        component: string,
        port: number = 5019,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/domains/{name}/prune',
            path: {
                'name': name,
            },
            query: {
                'port': port,
                'component': component,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }

}
